module.exports = __webpack_public_path__ + "static/img/gx.a59517a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/gx.png
// module id = cu2V
// module chunks = 1